import { OrderHeaderModel } from './order-header.model';
import { OrderLineModel } from './order-line.model';
import { RelatedOrderDto } from './related-order.dto';

export class OrderModel extends OrderHeaderModel {
  public products?: OrderLineModel[];
  public relatedOrders?: RelatedOrderDto[];
}
